import styled from 'styled-components';
import LogoMmtSvg from '../../assets/mytrips/logo-mmt.svg';

const LogoMmtIcon = styled(LogoMmtSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '2.9rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default LogoMmtIcon;
